import { useState } from "react";
import { approveIcon } from ".././Images";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../redux/apiSlice";
import { toastify, userlogout } from "../../redux/controller";

export const PaymentApproveModal = ({
  popstatus,
  handleClose,
  paymentInfo,
  handlePaymentApprove,
}) => {
  console.log("Payment Info ", paymentInfo);

  const usertoken = localStorage.getItem("usertoken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleApprovePayment = async () => {
    setIsLoading(true);
    try {
      var approvePaymentData = await dispatch(
        fetchData({
          apiurl: "/auth/user/approvepayment",
          landownerId: paymentInfo.landownerId,
          amount: paymentInfo.amount,
          paymenthistoryId: paymentInfo.paymenthistoryId,
          headers: { "x-access-token": usertoken },
        })
      );

      if (
        approvePaymentData &&
        approvePaymentData.payload &&
        approvePaymentData.payload.data &&
        approvePaymentData.payload.message
      ) {
        toastify({ message: approvePaymentData.payload.message });
        handlePaymentApprove();
      }

      if (
        approvePaymentData.payload.response &&
        approvePaymentData.payload.response.data &&
        approvePaymentData.payload.response.data.message
      ) {
        if (
          approvePaymentData.payload.response.data.message ===
            "Invalid token provided!" ||
          approvePaymentData.payload.response.data.message ===
            "No token provided!"
        ) {
          userlogout();
          navigate("/");
        }
      }
    } catch (error) {
      console.error("Approve payment error: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="manage_season_modal payment_approve_model">
      {popstatus && (
        <div className="managecou-popup">
          <div className="managecou-content">
            <i className="fa-solid fa-xmark" onClick={handleClose}></i>
            <div className="managecou-contentdiv">
              <img src={approveIcon} alt="approveIcon" />
              <h1>Are you Sure?</h1>
              <p>Are you sure you want to approve this payment?</p>
            </div>
            <div className="managecou-btn">
              <button className="btn1" onClick={handleClose}>
                Cancel
              </button>
              <button
                className="btnApprove2"
                onClick={handleApprovePayment}
                disabled={isLoading}
              >
                {isLoading ? "Approving..." : "Approve"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
